import axios from './axios';

const DriverService = {
   
    getDrivers: async (id,page) => {
        try {
            const response = await axios.get(`/drivers?page=${page}&count=10`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getCustomersCsv: async (id) => {
        try {
            const response = await axios.get(`/customers/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getDriverDetail: async (restId,id) => {
        try {
            const response = await axios.get(`/drivers/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getDriverHistory: async (restId,id) => {
        try {
            const response = await axios.get(`/drivers/${id}/history`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getCustomerFav: async (restId,id) => {
        try {
            const response = await axios.get(`/favorite-menu-items/${restId}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getDeliveryZone: async (restId) => {
        try {
            const response = await axios.get(`/delivery-zones`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    addDeliveryZone: async (payload) => {
        try {
            const response = await axios.post(`/delivery-zones`,payload);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    deleteDeliveryZone: async (id) => {
        try {
            const response = await axios.delete(`/delivery-zones/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    updateDeliveryZone: async (payload,id) => {
        try {
            const response = await axios.put(`/delivery-zones/${id}`,payload);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },

    getUnassignedOrder: async (id) => {
        try {
            const response = await axios.get(`/orders/unassigned`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },

    getOrders: async () => {
        try {
            const response = await axios.get(`/orders?fulfilled=true`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getOrdersPending: async () => {
        try {
            const response = await axios.get(`/orders?fulfilled=false`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getAllDrivers: async (id,page) => {
        try {
            const response = await axios.get(`/drivers`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    assignDriver: async (id,driverId) => {
        try {
            const response = await axios.post(`/orders/${id}/employees/${driverId}/assign-delivery`,{});
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
   
};

export default DriverService;
